import React,{useState,useEffect} from 'react';
import styled from "styled-components";
import ConfirmServed from "./ConfirmServed";
import { IconButton, Tooltip,Typography } from '@material-ui/core';
import StatusButtonLetter from "./StatusButtonLetter";
import WhatsappButtonLink from "./WhatsappButtonLink";
import CheckIcon from '@material-ui/icons/Check';
import {CalculateDiff} from "../../Utils/Dates";
import EditCostumer from './EditCostumer';
import EditStatus from './EditStatus';
import WhatsappButtons from "./WhatsappButtons";
import realtimeDB from '../../Utils/api';
import Alert from '../Alert';

const Container=styled.div`
display:grid;
background-color:white;
margin:7.5px 0;
width:100%;
height:auto;
grid-template-columns:min-content min-content min-content auto auto auto min-content  min-content;
align-items:center;
justify-items:start;
border-radius:20px;
-webkit-box-shadow: 2px 5px 15px 5px rgba(0,0,0,0.36); 
box-shadow: 2px 5px 15px 5px rgba(0,0,0,0.16);`;

const ContainerStatus=styled.div`
min-width:100%;`;

const Text=styled.h4`
font-weight:normal;
margin:0;
justify-self:center;`;

const ContainerButtons=styled.div`
display:grid;
grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
align-items: center;
grid-template-rows: 1fr;
justify-self:end;
font-weight:normal;

@media screen and (max-width:428px)
{
    justify-self:start;
}`;

const StyledP=styled.p`    
font-size: 24px;
display: flex;
justify-content: center;
align-items: center;
align-content: center;
align-self: center;
margin: 11px;

@media screen and (max-width:428px)
{
    font-size:16px;
}`;

const TextName=styled.p`
display:contents;
text-decoration:underline;
width: 110px;
margin:0 5px;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
font-weight:normal;
cursor:pointer;`;

const TextNote=styled.p`
width: 500px; 
justify-self:center;
margin:0 5px;
display: block;
overflow: hidden;
text-align:center;
white-space: nowrap;
text-overflow: ellipsis;
font-weight:normal;

@media screen and (max-width:1024px)
{
    width:200px;
}

@media screen and (max-width:700px)
{
    width:100px;
}

@media screen and (max-width:500px)
{
    width:75px;
}

@media screen and (max-width:428px)
{
    width:50px;
}
`;

const TextDiff=styled.h4`
margin:0 10px;
color:red;
align-self:center;`;

const getColor=status=>
{ 
    if(status==="confirming")
    {
        return "#fda634";
    }
    
    if(status==="annotated")
    {
        return "#fda634";
    }
    
    if(status==="waiting")
    {
        return "#fda634";
    }
    if(status==="coming")
    {
        return "#61cf45";
    }
    if(status==="no-info")
    {
        return "#ff1e06";
    }

}

const Customer=({customer,doubles,fourfolds})=>
{
    const {data,id}=customer;

    const [Index, setIndex] = useState("");
    const [Diff, setDiff] = useState(undefined);
    const [openConfirmServed, setopenConfirmServed] = useState(false);
    const [openEditCostumer, setopenEditCostumer] = useState(false);
    const [openChangeLetter, setopenChangeLetter] = useState(false);
    const {status,dinersCount,letter,name,note,date,phone}=data;
    const [MensajeAlerta, setMensajeAlerta] = useState(undefined);
    const [AlertaTipo, setAlertaTipo] = useState(undefined);
    
    const color=getColor(status);

    const CalculateTime=()=>
    {
        let diff=CalculateDiff(date);
        setDiff(diff);
    }

    useEffect(() => 
    {
        realtimeDB.ref("/Customers").on("value",snapshot =>
        {
            var Diners=[];
            var DinersGrandes=[];
        
            snapshot.forEach(diner =>
            {
                const Diner={data:diner.val(),id:(diner.key)};
                if(Diner.data.status!=="served" && Diner.data.status!=="cancelled" && Diner.data.status!=="no-info")
                {
                    if(Diner.data.dinersCount<=2)
                    {
                        Diners.push(Diner);
                    }
                    else
                    {
                        DinersGrandes.push(Diner);
                    }
                }
            });

            var Posicion=undefined;
            if(dinersCount<=2)
            {
            
                Diners=Diners.sort((a, b) => (a.data.date > b.data.date ) ? 1 : (a.data.date  === b.data.date ) ? ((a.data.date  > b.data.date ) ? 1 : -1) : -1 );
                Posicion=Diners.findIndex(diner => diner.id==id)
            }
            else
            {
                DinersGrandes=DinersGrandes.sort((a, b) => (a.data.date > b.data.date ) ? 1 : (a.data.date  === b.data.date ) ? ((a.data.date  > b.data.date ) ? 1 : -1) : -1 );
                Posicion=DinersGrandes.findIndex(diner => diner.id==id)
            }
            setIndex(Posicion+1);
        });

        CalculateTime();
    }, [])

    const changeStatusConfirmModal=()=>
    {
        setopenConfirmServed(!openConfirmServed);
    }

    const changeLetter=()=>
    {
        setopenChangeLetter(!openChangeLetter);
    }

    const changeStatusEdit=()=>
    {
        setopenEditCostumer(!openEditCostumer);
    }

    const mq=window.matchMedia( "(max-width: 500px)" );
    const MobileSize=mq.matches ? true : false;

    const ButtonsWhatsapp=()=>
    {
        const ButtonConfirm=()=>
        {
            return <Tooltip title={<Typography fontSize={15}>Confirmar</Typography>} placement='bottom-start'>
                <IconButton onClick={changeStatusConfirmModal}>
                    <CheckIcon/>
            </IconButton>
            </Tooltip>
        }

        if(MobileSize)
        {
            return <ContainerButtons>
                <WhatsappButtons Index={Index} id={id} phone={phone} status={status} dinersCount={dinersCount}/>
                <ButtonConfirm/>
            </ContainerButtons>
        }
        else
        {       
            return <>
            <ContainerButtons>
                <WhatsappButtonLink letter="C" customer={customer} setAlertaTipo={setAlertaTipo} setMensajeAlerta={setMensajeAlerta}/>
                {MobileSize ? null :   <WhatsappButtonLink letter="S" customer={customer} setAlertaTipo={setAlertaTipo} setMensajeAlerta={setMensajeAlerta}/>}
                {MobileSize ? null :   <WhatsappButtonLink letter="?" customer={customer} setAlertaTipo={setAlertaTipo} setMensajeAlerta={setMensajeAlerta}/> }
                <WhatsappButtonLink letter="X" customer={customer} setAlertaTipo={setAlertaTipo} setMensajeAlerta={setMensajeAlerta}/>
                <ButtonConfirm/>
            </ContainerButtons> 
            </>
        } 
    }

    return <>
        <Container>
            <StyledP>{Index}</StyledP>
            <ContainerStatus onClick={changeLetter}>
                <StatusButtonLetter color={color} letter={letter} customer={customer}/>
            </ContainerStatus>
            <Text style={{margin:"0 5px"}}>{dinersCount}</Text>
            <TextName onClick={changeStatusEdit}>{name}</TextName> 
            <Text>{phone}</Text>
            <TextNote >{note}</TextNote>    
            <TextDiff> {Diff} </TextDiff>    
            <ButtonsWhatsapp/>
        </Container>
    <ConfirmServed customers={ data.dinersCount<=2 ? doubles : fourfolds } index={Index} customer={customer} open={openConfirmServed}  setAlertaTipo={setAlertaTipo} setMensajeAlerta={setMensajeAlerta}  close={changeStatusConfirmModal}/>
    <EditCostumer customer={customer} open={openEditCostumer} close={changeStatusEdit}/>
    <EditStatus customer={customer} open={openChangeLetter} close={changeLetter}/>
    <Alert type={AlertaTipo} mensaje={MensajeAlerta} close={() => setMensajeAlerta("")}/>
    </>

}

export default Customer;
